export function isSeoHtmlOptimizationsEnabled(isInSEO: boolean, requestUrl: string): boolean {
	return isInSEO || requestUrl.includes('forceSeoHtmlOptimizations=true')
}
